import { myAppList, getAuthCode } from "@/graphql/Home.gql";
import { Module } from "vuex";
import { RootState } from "./../types/index";
export interface IApplist {
  appCode: string;
  appName: string;
  appUrl: string;
  appDesc?: string;
}
interface IState {
  appList: IApplist[];
}
export const state: IState = {
  appList: []
};
export const home: Module<IState, RootState> = {
  namespaced: true,
  state,
  actions: {
    async getAppList({ rootState, commit }: any, data) {
      let {
        data: { queryMyAppList }
      } = await rootState.gql.query({ query: myAppList });
      if (queryMyAppList.length) {
        queryMyAppList.forEach(_ => {
          if (_.appPicture) {
            const list = _.appPicture.split(",");
            _.logo = list[1];
            _.logoHover = list[0];
            _.bg = list[2];
          }
        });
      }
      commit("setDataList", queryMyAppList);
    },
    async getAuthCode({ rootState, commit }: any, data) {
      let res = await rootState.gql.query({
        query: getAuthCode,
        variables: data
      });
      return res.data;
    }
  },
  mutations: {
    setDataList(state: IState, data: IApplist[]) {
      state.appList = data;
    }
  }
};
export default home;
